<div class="row">
  <mat-form-field appearance="outline" style="height: 50px" [ngClass]="allClasses" [style]="customStyle">

    <input matInput placeholder="{{ 'search' | translate }}" [matAutocomplete]="auto"
      (keyup)="onSearch($event.target.value)" #autoTrigger="matAutocompleteTrigger" [formControl]="searchControl" />

    <mat-autocomplete #auto="matAutocomplete" (opened)="onAutocompleteOpened(autoTrigger)"
      (optionSelected)="onSelect($event.option.value)">
      <mat-option *ngFor="let item of filteredOptions" [value]="item">
        {{ item[selectValue] }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
